export default "__VITE_ASSET__C$bp9IG7__"